const DEFAULTS = {
  duration: 300,
  done: () => {},
};

let globalOptions = {};

const isAnimatingStyle = {
  transition: 'opacity ease 500ms',
};

const outStyle = {
  opacity: 0,
};

export default function fadeOut(el, options) {
  globalOptions = { ...DEFAULTS, ...options };
  isAnimatingStyle.transition = `opacity ${globalOptions.duration}ms ease`;
  animateOut(el);
}

function animateOut(el) {
  el.addEventListener('transitionend', removeTransition);
  Object.assign(el.style, isAnimatingStyle);
  window.requestAnimationFrame(() => {
    Object.assign(el.style, outStyle);
  });
}

function removeTransition(e) {
  // @TODO: This is causing issues with the parts request form, figure out root cause
  if (!e.target.hasAttribute('data-label') && !e.target.hasAttribute('data-comp-button')) {
    Object.assign(e.target.style, {
      transition: '',
      display: 'none',
    });
    e.target.removeEventListener('transitionend', removeTransition);
    globalOptions.done();
  }
}
